import type { RouteLocationNormalizedGeneric } from 'vue-router'

/**
 * Sentinel returned when no route in `routeLocation.matched` resolves the
 * incoming URL (typically a 404 with no catch-all). Returning the raw
 * `routeLocation.path` here would explode metric cardinality on
 * `http.server.request.duration`, so we collapse all unmatched URLs into a
 * single bucket.
 */
export const UNKNOWN_ROUTE = 'unknown'

/**
 * Extracts the route template path from a RouteLocation.
 *
 * Returns the template (e.g. "/:locale/p/:slug") of the last matched route,
 * or {@link UNKNOWN_ROUTE} when nothing matched.
 */
export function getRoutePath(
  routeLocation: RouteLocationNormalizedGeneric,
): string {
  // Avoid Array.prototype.at due to browser compat
  const matchedRoute = routeLocation.matched[routeLocation.matched.length - 1]
  if (!matchedRoute) {
    return UNKNOWN_ROUTE
  }

  // path can include matched params in (), e.g. /:locale(en-us)/ we strip
  // these to keep cardinality low
  return matchedRoute.path.replace(/\([a-zA-Z|-]+\)/g, '')
}
